import { FormattedMessage, useIntl } from "react-intl";

import { transformChunks } from "shared/components/TextWrapper";
import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type UseAutoCreatedListConfirmationModalProps = Pick<
  YesNoModalProps,
  "onClickYes" | "onClickNo"
>;

export function UseAutoCreatedListConfirmationModal({
  onClickYes,
  onClickNo,
}: UseAutoCreatedListConfirmationModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.use-auto-created-list-confirmation-modal.title",
      })}
      body={
        <FormattedMessage
          id="components.use-auto-created-list-confirmation-modal.body"
          values={transformChunks({ b: { as: "strong" } })}
        />
      }
      yesLabel={intl.formatMessage({
        id: "components.use-auto-created-list-confirmation-modal.use-auto-created-list",
      })}
      noLabel={intl.formatMessage({
        id: "components.use-auto-created-list-confirmation-modal.delete-and-create-manually",
      })}
      isGrey
    />
  );
}
